import * as React from "react";
const SvgEdit = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M-0.00125122 14.2513V18.0013H3.74875L14.8087 6.94128L11.0587 3.19128L-0.00125122 14.2513ZM17.7087 4.04128C18.0987 3.65128 18.0987 3.02128 17.7087 2.63128L15.3687 0.291279C14.9787 -0.0987207 14.3487 -0.0987207 13.9587 0.291279L12.1287 2.12128L15.8787 5.87128L17.7087 4.04128Z",
	fill: "#808080"
}));
export default SvgEdit;
